import * as React from 'react';
import { Link } from 'react-scroll';
import { Field, reduxForm } from 'redux-form';
import focusInputOnError from '../helpers/focusInputOnError';
import validate from '../helpers/quoteFormValidate';
import { formatRut } from '../helpers/utils';
import { FormInput, FormNumber, FormSelect } from './';
import ReactGA from 'react-ga4';

const options = [
  {
    name: 'Sin cargas',
    value: '0',
  },
  {
    name: '1 Carga',
    value: '1',
  },
  {
    name: '2 Cargas',
    value: '2',
  },
  {
    name: '3 Cargas',
    value: '3',
  },
];

export function QuoteForm(props: any) {
  const { handleSubmit } = props;

  function handleChange(event: any) {
    const optionResult = options.find(e => e.value === event.target.value);
    ReactGA.event('user_interaction', {
      action: optionResult?.name.replace(' ', '-').toLowerCase(),
      location: 'paso-visita',
      flow: 'salud-complementario',
    });
  }

  return (
    <form onSubmit={handleSubmit} noValidate={true}>
      <div className="row flex-column">
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 form-group mx-auto mb20">
          <label htmlFor="documentId">Rut</label>
          <Field
            name="documentId"
            type="text"
            placeholder="Ej 12.345.678-9"
            component={FormInput}
            normalize={formatRut}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 form-group mx-auto mb20">
          <label htmlFor="birthdate">Fecha de nacimiento</label>
          <Field
            name="birthdate"
            placeholder="01-01-1999"
            inputFormat="##-##-####"
            mask={['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a']}
            component={FormNumber}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 form-group mx-auto mb20">
          <label htmlFor="charges">Número asegurados adicionales</label>
          <Field
            name="charges"
            placeholder="Selecciona"
            options={options}
            component={FormSelect}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 form-group mx-auto mb20">
          <label htmlFor="email">Correo</label>
          <Field
            name="email"
            type="email"
            placeholder="ejemplo@dominio.com"
            component={FormInput}
          />
        </div>
        <div className="col-12 col-sm-8 col-md-6 col-lg-4 form-group mx-auto mb-0">
          <label htmlFor="phone">Teléfono</label>
          <Field
            name="phone"
            placeholder="9 9999 9999"
            inputFormat="# #### ####"
            isPhone={true}
            component={FormNumber}
          />
        </div>
      </div>
      <footer className="fixed-footer-form">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-sm-8 col-md-7 col-lg-6 pdy-16 d-flex justify-content-center align-content-center align-items-center">
              <Link
                className="cursor-pointer text-dark-gray px-16 hidden-item-desktop"
                activeClass="active"
                to="coverage-and-benefits"
                spy={true}
                smooth={true}
                offset={-50}
                duration={500}
              ><img src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/hand.svg" alt="" /> Coberturas y beneficios</Link>
              <button id="quote" className="btn primary px-16" type="submit">
                Cotizar
              </button>
            </div>
          </div>
        </div>
      </footer>
    </form>
  );
}

export default reduxForm({
  form: 'quote',
  onSubmitFail: focusInputOnError,
  validate,
})(QuoteForm);
